// export const baseUrl = "https://rainfall.zeroiq.com";
export const baseUrl = "https://cdn-ext.rainfall.one/api";
export const imageBaseUrl = "https://cdn-ext.rainfall.one";
export const payloadImgUrl = "https://testcms.eng.rainfall.one";

export const stagingConfig = {
  baseUrl: "https://cdn-ext.rainfall.one/api",
  imageBaseUrl: "https://cdn-ext.rainfall.one",
  
  webUrl: "https://staging.rainfall.one/",
  faqURL: "https://staging.rainfall.one/resources/FAQ",
  contactSheet:
    "https://sheet.best/api/sheets/3999aa0e-e6b9-467f-90d1-86b83703305a/tabs/Contact",
  waitingListSheet:
    "https://sheet.best/api/sheets/3999aa0e-e6b9-467f-90d1-86b83703305a/tabs/WaitingList",
  investorsSheet:
    "https://sheet.best/api/sheets/2494f537-722f-4817-9613-0acd5e5850d8/tabs/Investors",
  dayInTheLifeSheet:
    "https://sheet.best/api/sheets/3999aa0e-e6b9-467f-90d1-86b83703305a/tabs/DayInTheLife",
  idMapper: {
    privacyApp: "15",
    termsApp: "14",
    termsWallet: "3",
    cookies: "5",
    privacy: "6",
    terms: "7",
  },
  emailConfigurations: {
    userId: "U8FF289Q18aBytpV3",
    serviceId: "service_0ud0j8b",
    contactUsServiceId: "service_6esmp7a",
    templateId: "template_ybykzs3",
    templateIdv: "template_uk4hxnk",
    templateNillion:"template_m6gnykn",
    templateStarAura: "template_o9vleba",
    contactTemplateId: "template_m8eweph",
    subscribeTemplateRainmaker: "template_alkhadr",
    subscribeTemplateAethir: "template_f1vwzgq",
    subscribeTemplateId: "template_51lcbso",
  },
  firebaseConfig: {
    // apiKey: "AIzaSyA7Ro-nSjWU99SgnFlf7wGYyEuZRcfuPWI",
    // apiKey: "AIzaSyA-TzpWXLBZZcEtGjNzCZmZuSP2Qnrcbm4",
    // authDomain: "rainfall-development.firebaseapp.com",
    // projectId: "rainfall-development",


  apiKey: "AIzaSyA-TzpWXLBZZcEtGjNzCZmZuSP2Qnrcbm4",
  authDomain: "rainfall-development.firebaseapp.com",
  // databaseURL: "https://rainfall-development-default-rtdb.firebaseio.com",
  projectId: "rainfall-development",
  storageBucket: "rainfall-development.appspot.com",
  messagingSenderId: "965115617358",
  appId: "1:965115617358:web:845baad88c7f61e954231f",
  measurementId: "G-PL14PDJFJQ"


  },
  db: {
    collectionName: "inbound-contacts",
    loginCollectionName: "inbound-contacts-login",
    encryptionPasskey: "rainfall",
  },
};

export const productionConfig = {
  baseUrl: "https://cdn-ext.rainfall.one/api",
  imageBaseUrl: "https://cdn-ext.rainfall.one",
  webUrl: "https://rainfall.one/",
  faqURL: "https://rainfall.one/resources/FAQ",
  contactSheet:
    "https://sheet.best/api/sheets/4ac3e564-d64e-4964-b257-8ba02e92ab99/tabs/Contact",
  waitingListSheet:
    "https://sheet.best/api/sheets/4ac3e564-d64e-4964-b257-8ba02e92ab99/tabs/WaitingList",
  investorsSheet:
    "https://sheet.best/api/sheets/b3ad1358-be95-4f53-b81b-9df922b0e9d5/tabs/Investors",
  dayInTheLifeSheet:
    "https://sheet.best/api/sheets/4ac3e564-d64e-4964-b257-8ba02e92ab99/tabs/DayInTheLife",
  idMapper: {
    privacyApp: "15",
    termsApp: "14",
    termsWallet: "3",
    cookies: "5",
    privacy: "6",
    terms: "7",
  },
  emailConfigurations: {
    userId: "ysRP_pvwUigD3F0RO",
    serviceId: "service_mwj7zc7",
    contactUsServiceId: "service_6esmp7a",
    templateId: "template_ybykzs3",
    templateNillion:"template_m6gnykn",
    templateStarAura: "template_o9vleba",
    templateIdv: "template_uk4hxnk",
    contactTemplateId: "template_m8eweph",
    subscribeTemplateRainmaker: "template_alkhadr",
    subscribeTemplateAethir: "template_f1vwzgq",
    templateIdv: "template_uk4hxnk",
  },
  firebaseConfig: {
    apiKey: "AIzaSyBUU6opbKExHotvU1to_4QVj-r0rXOXHKo",
    authDomain: "rainfall-production.firebaseapp.com",
    projectId: "rainfall-production",
    storageBucket: "rainfall-development.appspot.com",
    messagingSenderId: "965115617358",
    appId: "1:965115617358:web:845baad88c7f61e954231f",
    measurementId: "G-PL14PDJFJQ"
  },
  db: {
    collectionName: "inbound-contacts",
    loginCollectionName: "inbound-contacts-login",
    encryptionPasskey: "rainfall",
  },
};

export const FORM_TYPE = {
  WAITING_LIST: "waiting_list",
  CONTACT_FORM: "contact_form",
  INVESTORS: "investors",
  INVESTMENT: "investment",
  DAY_IN_THE_LIFE: "day_in_the_life",
  BETA_APP: "beta_app",
  VVV : "rainmaker",
  Nillion : "nillion",
  NEWS_LETTER: "news_letter",
  TBC_POOL: "tbc_pool",
  Aethir: "aethir",
};
